import React from 'react'
import { useSelector } from 'react-redux';
import { selectMoldReleaseFilterVisible, selectTileView } from './store/selectors'; // Import the selector
import MoldReleaseSearch from './mold-release-search';
import MoldReleaseFilter from './mold-release-filter';
import MoldReleaseTile from './mold-release-tile';
import MoldReleaseTable from './mold-release-table';

const MoldReleaseContent = props => {
    const isFilterVisible = useSelector(selectMoldReleaseFilterVisible); // Use the selector
    const showTileView = useSelector(selectTileView); // Use the selector
  return (
    <div className="card table-list-card">
    <div className="card-body">
      <div className="table-top">
        <MoldReleaseSearch />
      </div>
      {isFilterVisible && <MoldReleaseFilter />}

      {!showTileView ? <MoldReleaseTile /> : <MoldReleaseTable />}
    </div>
  </div>
);
};

export default MoldReleaseContent